<div class="loader-body" *ngIf="loader">
    <div class="loader">
        <div>
            <ul>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
                <li>
                    <svg fill="currentColor" viewBox="0 0 90 120">
                        <path
                            d="M90,0 L90,120 L11,120 C4.92486775,120 0,115.075132 0,109 L0,11 C0,4.92486775 4.92486775,0 11,0 L90,0 Z M71.5,81 L18.5,81 C17.1192881,81 16,82.1192881 16,83.5 C16,84.8254834 17.0315359,85.9100387 18.3356243,85.9946823 L18.5,86 L71.5,86 C72.8807119,86 74,84.8807119 74,83.5 C74,82.1745166 72.9684641,81.0899613 71.6643757,81.0053177 L71.5,81 Z M71.5,57 L18.5,57 C17.1192881,57 16,58.1192881 16,59.5 C16,60.8254834 17.0315359,61.9100387 18.3356243,61.9946823 L18.5,62 L71.5,62 C72.8807119,62 74,60.8807119 74,59.5 C74,58.1192881 72.8807119,57 71.5,57 Z M71.5,33 L18.5,33 C17.1192881,33 16,34.1192881 16,35.5 C16,36.8254834 17.0315359,37.9100387 18.3356243,37.9946823 L18.5,38 L71.5,38 C72.8807119,38 74,36.8807119 74,35.5 C74,34.1192881 72.8807119,33 71.5,33 Z">
                        </path>
                    </svg>
                </li>
            </ul>
        </div><span>{{'loading' | translate}}</span>
    </div>
</div>

<section *ngIf="!loader">
    <div class="rbt-page-banner-wrapper">
        <!-- Start Banner BG Image  -->
        <div class="rbt-banner-image"></div>
        <!-- End Banner BG Image  -->
        <div class="rbt-banner-content">

            <!-- Start Banner Content Top  -->
            <div class="rbt-banner-content-top">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <!-- Start Breadcrumb Area  -->
                            <ul class="page-list">
                                <li class="rbt-breadcrumb-item"><a routerLink="/home">{{'home' | translate}}</a></li>
                                <li>
                                    <div class="icon-right"><i class="feather-chevron-left"></i></div>
                                </li>
                                <li class="rbt-breadcrumb-item active">{{'Courses' | translate}}</li>
                            </ul>
                            <!-- End Breadcrumb Area  -->

                            <div class=" title-wrapper">
                                <h1 class="title mb--0">{{'AllCourses' | translate}}</h1>
                                <a  class="rbt-badge-2" style="cursor: default;">
                                     {{this.totalItems}} {{'course' | translate}}
                                </a>
                            </div>

                            <p class="description">{{'allCoursesSlogan' | translate}} </p>
                        </div>
                    </div>
                </div>
            </div>


            <div class="rbt-course-top-wrapper mt--40 mt_sm--20">
                <div class="container">
                    <div class="default-exp-wrapper">
                        <div class="filter-inner">
                            <div class="filter-select-option">
                                <div class="filter-select rbt-modern-select">
                                    <span class="select-label d-block">{{'teachers' | translate}}</span>
                                    <div class="rbt-modern-select bg-transparent height-45 w-100 mb--10">
                                        <dx-select-box id="teacherId" name="teacherId"  searchMode="contains" [showDropDownButton]="false" [dataSource]="teachers"
                                        [rtlEnabled]="this.baseService.isRTL" class="borderStyle" placeholder="" [showClearButton]="true" placeholder="{{'teacherSearch' | translate}}" (onInitialized)="getTeachers($event)"
                                        displayExpr="fullName" valueExpr="id" ngModel #teacherId="ngModel" [searchEnabled]="true" (onSelectionChanged)="getTeacherId($event)">
                                        </dx-select-box>
                                    </div>
                                </div>
                            </div>

                            <div class="filter-select-option">
                                <div class="filter-select rbt-modern-select">
                                    <span class="select-label d-block">{{'Category' | translate}}</span>
                                    <div class="rbt-modern-select bg-transparent height-45 w-100 mb--10">
                                        <dx-select-box id="categoryId" name="categoryId"  searchMode="contains" [showDropDownButton]="false" [dataSource]="categories"
                                        [rtlEnabled]="this.baseService.isRTL" class="borderStyle" placeholder="" [showClearButton]="true" placeholder="{{'catSearch' | translate}}" (onInitialized)="getCategory($event)"
                                        displayExpr="nameAr" valueExpr="id" ngModel #categoryId="ngModel" [searchEnabled]="true" (onSelectionChanged)="getCategoryId($event)">
                                        </dx-select-box>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- End Banner Content Top  -->
        </div>
    </div>

    <div class="rbt-section-overlayping-top rbt-section-gapBottom">
        <div class="inner">
            <div class="container" *ngIf="noCoursesForThisTeacherSection">
                <div class="noCoursesMsg" style="text-align: center;">
                    <h1>{{'noCourses' | translate}}</h1>
                </div>
            </div>

            <div class="container" *ngIf="!noCoursesForThisTeacherSection">
                <div class="rbt-course-grid-column">

                    <!-- Start Single Card  -->
                    <div class="course-grid-3" *ngFor="let course of courses">
                        <div class="rbt-card variation-01 rbt-hover" *ngIf="course.hide === false">
                            <div class="rbt-card-img" (click)="openDetail(course.id)">
                                <a>
                                    
                                    
                                    <span *ngIf="course.status === 'Completed'" class="Completed"><span class="dot_blue"></span> {{'Completed' | translate}} </span>
                                    <span *ngIf="course.status === 'Finished'" class="Finished"><span class="dot_red"></span> {{'Finished' | translate}} </span>
                                    <span *ngIf="course.status === 'Closed'" class="Finished"><span class="dot_red"></span> {{'Closed' | translate}} </span>
                                    <span *ngIf="course.status === 'Available'" class="availabe"><span class="dot_green"></span> {{'Available' | translate}}</span>
                                    <img style="max-height: 220px;min-height: 220px;" [src]="this.baseService.appUrl + course.thumbNail" onerror=" this.onerror=null;this.src='assets/images/bg/bg-g100.webp';" alt="Card image" loading="lazy">
                                </a>
                            </div>
                            <div class="rbt-card-body">
                                <div class="rbt-card-top">
                                    <div class="rbt-review">
                                        <div class="rating" *ngIf="course.rating === 5">
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                        </div>
                                        <div class="rating" *ngIf="course.rating > 4 && course.rating < 5">
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                        </div>
                                        <div class="rating" *ngIf="course.rating > 3 && course.rating < 4">
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                        </div>
                                        <div class="rating" *ngIf="course.rating > 2 && course.rating < 3">
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                        </div>
                                        <div class="rating" *ngIf="course.rating > 1 && course.rating < 2">
                                            <i class="fas fa-star"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                        </div>
                                        <div class="rating" *ngIf="course.rating < 1">
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color: #A1A9AC;"></i>
                                            <i class="fas fa-star" style="color:  #A1A9AC;"></i>
                                        </div>
                                    </div>
                                </div>

                                <h4 class="rbt-card-title" (click)="openDetail(course.id)"><a>{{course.courseNameAr}}</a>
                                </h4>

                                <ul class="rbt-meta">
                                    <li>{{course.lessons}} {{'Lessons' | translate}}</li>
                                    <li>{{course.studentsNo}} {{'Students' | translate}}</li>

                                    <li style="float: inline-end;">{{'from' | translate}} {{course.startDate | date: 'dd/MM'}} {{'To' | translate}} {{course.endDate | date: 'dd/MM'}}</li>
                                </ul>

                                <p class="rbt-card-text">{{course.summary}}</p>
                                <div class="rbt-author-meta mb--10">
                                    <div class="rbt-avater">
                                        <a >
                                            <img style="aspect-ratio: 1 / 1;" [src]="this.baseService.appUrl + this.course.teacherProfileImg" onerror=" this.onerror=null;this.src='assets/images/client/avatar.png';" alt="Sophia Jaymes">
                                        </a>
                                    </div>
                                    <div class="rbt-author-info">
                                        {{'By' | translate}} <a (click)="viewTeacherProfile(course.teacherId)">{{course.teacherName}}  {{course.teacherSurName}}</a> {{'in' | translate}} {{course.categoryNameAr}}
                                        
                                    </div>
                                </div>
                                <div class="rbt-card-bottom">
                                    <div class="rbt-price" *ngIf="course.price === 0">
                                        <span class="current-price">{{'Free' | translate}}</span>
                                    </div>
                                    <div class="rbt-price" *ngIf="course.price > course.offerPrice">
                                        <span class="current-price">{{course.offerPrice}} {{'SAR' | translate}}</span>
                                        <span class="off-price">{{course.price}} {{'SAR' | translate}}</span>
                                    </div>
                                    <div class="rbt-price" *ngIf="course.offerPrice > course.price">
                                        <span class="current-price">{{course.price}} {{'SAR' | translate}}</span>
                                    </div>
                                    <a class="rbt-btn-link" (click)="openDetail(course.id)">{{'details' | translate}}</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!hidePagenation">
                    <div class="col-lg-12 mt--60">
                        <nav>
                            <ul class="rbt-pagination">
                                <li><button style="border: none;" (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1" aria-label="Previous"><i class="feather-chevron-left"></i></button></li>
                                <span>{{'Page' | translate}} {{ currentPage }} {{'of' | translate}} {{ totalPages }}</span>
                                <li><button style="border: none;" (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages" aria-label="Next"><i class="feather-chevron-right"></i></button></li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <!-- <div class="row" *ngIf="searchedResults">
                    <div class="col-lg-12 mt--60">
                        <pagination-controls 
                        class="rbt-pagination" 
                        (pageChange)="p = $event"
                        previousLabel=""
                        nextLabel=""
                        ></pagination-controls>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</section>
